const Marionette = require('backbone.marionette');
const authMgr = require('app/authMgr');
const notify = require('shared/eventHandlers/notify');
// Since app is a dependency of nearly everything, this file needs to have a bare minimum of internal dependencies.
// Moving all the app startup logic to appInit.js accomplishes separating the app's instantiation dependencies from it's startup dependencies.
const app = Marionette.Application.extend({
    ... notify,
    region: '#appRegion',
    onDomChangeTitle: function (title) {
        $(document).attr('title', title);
    },
    initialize: function () {
        this.authMgr = authMgr;
    }
});
module.exports = new app;